import { createDataLayer } from '@shared/v2/utils/dataLayer';

import { GTM_DEBUG_EVENTS } from '@/config';

const dataLayer = createDataLayer({ useDebug: GTM_DEBUG_EVENTS === 'true' });
export default dataLayer;
